
export const focusProps = {
	borderColor: 'primary.500',
	boxShadow: '0 0 0 2px var(--chakra-colors-primary-100)',
	// zIndex: 2,
}
